import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { POLL } from "../lib/polling";

export function useDispute(disputeId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.dispute(disputeId ?? ""),
    queryFn: ({ signal }) => apiClient.getDispute(disputeId as string, signal),
    enabled: Boolean(disputeId),
    // Evidence, rebuttals and the resolution all arrive from the other side; stop once decided.
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === "RESOLVED" || status === "REJECTED" ? false : POLL.live;
    },
  });
}
